import React from 'react';
import { Progress } from 'antd';

import {
  headerKeyMapping,
  weightageHeaders,
  getHitLevelByScore,
  getAlertColorCode
} from './constants';

import style from './results.scss';
import get from 'lodash/get';
import moment from 'moment';

const ResultsComponent = (props) => {
  const { searchResults, formData, profileMatchingArray } = props;
  const getAddressValue = () => {
    const residentialAddress = [
      'addressLine1',
      'addressLine2',
      'country',
      'city',
      'postCode'
    ];
    let residentialAddressValue = '';
    residentialAddress.map((key) => {
      if (formData[`${key}`]) {
        residentialAddressValue = residentialAddressValue
          ? `${residentialAddressValue}` + ' ' + formData[`${key}`]
          : formData[`${key}`];
      }
    });
    return residentialAddressValue;
  };

  const getDateOfBirth = () => {
    let formatDate = '';
    if (formData['dateOfBirth']) {
      formatDate = moment(formData['dateOfBirth']).format('DD/MM/YYYY');
    }
    return formatDate;
  };

  const headerData = {
    hitDetail: {
      hitLevel: { label: 'Hit Level', value: '' },
      hitScore: { label: 'Hit Score', value: '' }
    },
    comparison: {
      name: { label: 'Name', value: get(formData, 'name', '-') },
      alias: { label: 'Alias', value: get(formData, 'alias', '-') },
      address: {
        label: 'Address',
        value: getAddressValue()
      },
      dateOfBirth: { label: 'Birth/Inception Date', value: getDateOfBirth() },
      nationality: {
        label: 'Nationality',
        value: get(formData, 'nationality', '-')
      },
      countryofBirth: {
        label: 'Country of Birth/Inception',
        value: get(formData, 'countryofBirth', '-')
      },
      country: {
        label: 'Country of Residence',
        value: get(formData, 'country', '-')
      }
    },
    nameMatchingScore: {
      nameNameMatch: {
        label: 'Name-Name Match',
        props: {
          weight: {
            label: 'Weight',
            value: '-'
          },
          score: { label: 'Score', value: '-' }
        },
        value: get(formData, 'name', '-')
      },
      nameAliasMatch: {
        label: 'Name-Alias Match',
        props: {
          weight: {
            label: 'Weight',
            value: '-'
          },
          score: { label: 'Score', value: '-' }
        },
        value: get(formData, 'alias', '-')
      }
    },
    profileMatchingFeatures: {
      addressMatch: {
        label: 'Address Match',
        props: {
          weight: {
            label: 'Weight',
            value: '-'
          },
          score: { label: 'Score', value: '-' }
        },
        value: getAddressValue()
      },
      dateOfBirthMatch: {
        label: 'Date of Birth Match',
        props: {
          weight: {
            label: 'Weight',
            value: '-'
          },
          score: { label: 'Score', value: '-' }
        },
        value: getDateOfBirth()
      },
      countryofBirthMatch: {
        label: 'Country of Birth Match',
        props: {
          weight: {
            label: 'Weight',
            value: '-'
          },
          score: { label: 'Score', value: '-' }
        },
        value: get(formData, 'countryofBirth', '-')
      },
      nationalityMatch: {
        label: 'Nationality Match',
        props: {
          weight: {
            label: 'Weight',
            value: '-'
          },
          score: { label: 'Score', value: '-' }
        },
        value: get(formData, 'nationality', '-')
      }
    }
  };

  const hits = get(searchResults, 'data.hits.hits', null);
  const data = [];

  if (hits?.length) {
    hits.forEach((hit) => {
      let dataObj = {};
      let dobDetailsRoot = get(hit, '_explanation.details', []);
      let addressDetailsRoot = get(dobDetailsRoot, '0.details.0.details', []);
      let nameDetailsRoot = get(addressDetailsRoot, '0.details.0.details', []);
      let nameAliasMatch = get(nameDetailsRoot, '0.details.0.details', []);
      const doc_score = get(
        nameAliasMatch,
        '0.details.0.details.1.details.0.details.1.details.0.description',
        ''
      );
      const doc_store_fields = doc_score
        ? get(JSON.parse(doc_score), 'doc_score.fields', [])
        : [];
      const doc_store_fields_mapping = {};
      doc_store_fields?.forEach((el) => {
        doc_store_fields_mapping[`${el?.field_name}`] = el;
      });
      let watchlistAlias = '';
      if (get(hit, '_source.WATCHLIST_ALIAS')?.length) {
        get(hit, '_source.WATCHLIST_ALIAS').forEach((aliasName) => {
          watchlistAlias += aliasName?.['NAME']?.['data'] + '  ;  ';
        });
      }
      dataObj['hitDetail'] = {
        hitLevel: {
          label: 'Hit Level',
          value: getHitLevelByScore(
            get(hit, '_score') ? get(hit, '_score') * 100 : 0
          )
        },
        hitScore: {
          label: 'Hit Score',
          value: get(hit, '_score')
            ? (get(hit, '_score') * 100).toFixed(2).toString()
            : '-'
        }
      };
      dataObj['comparison'] = {
        name: {
          label: 'Name',
          value: get(hit, '_source.WATCHLIST_NAME.data', '-')
        },
        alias: {
          label: 'Alias',
          value: watchlistAlias
        },
        address: {
          label: 'Address',
          value: get(hit, '_source.WATCHPERSON_RESIDENTIAL_ADDRESS.data', '-')
        },
        dateOfBirth: {
          label: 'Date Of Birth',
          value: get(hit, '_source.DATE_OF_BIRTH')
            ? moment(get(hit, '_source.DATE_OF_BIRTH')).format('DD/MM/YYYY')
            : '-'
        },
        nationality: {
          label: 'Nationality',
          value: get(hit, '_source.WATCHLIST_NATIONALITY', '-')
        },
        countryofBirth: {
          label: 'Country of Birth/Inception',
          value: get(hit, '_source.WATCHLIST_COUNTRY_OF_BIRTH', '-')
        },
        country: {
          label: 'Country of Residence',
          value: get(hit, '_source.WATCHPERSON_RESIDENTIAL_ADDRESS.data', '-')
        }
      };
      dataObj['nameMatchingScore'] = {
        nameNameMatch: {
          label: 'Name-Name Match',
          props: {
            weight: {
              label: 'Weight',
              value: get(nameDetailsRoot, '1.details.1.value')
                ? get(nameDetailsRoot, '1.details.1.value')
                    .toFixed(2)
                    .toString()
                : get(nameDetailsRoot, '1.details.1.value') == 0
                ? 0
                : '-'
            },
            score: {
              label: 'Score',
              value: get(nameDetailsRoot, '1.details.0.value')
                ? get(nameDetailsRoot, '1.details.0.value')
                    .toFixed(2)
                    .toString()
                : get(nameDetailsRoot, '1.details.0.value') == 0
                ? 0
                : '-'
            }
          },
          value: get(hit, '_source.WATCHLIST_NAME.data', '-')
        },
        nameAliasMatch: {
          label: 'Name-Alias Match',
          props: {
            weight: {
              label: 'Weight',
              value:
                formData['alias'] && get(nameAliasMatch, '1.details.1.value')
                  ? get(nameAliasMatch, '1.details.1.value')
                      .toFixed(2)
                      .toString()
                  : '-'
            },
            score: {
              label: 'Score',
              value:
                formData['alias'] && get(nameAliasMatch, '1.details.0.value')
                  ? get(nameAliasMatch, '1.details.0.value')
                      .toFixed(2)
                      .toString()
                  : '-'
            }
          },
          value: formData['alias'] ? watchlistAlias : '-'
        }
      };
      dataObj['profileMatchingFeatures'] = {
        addressMatch: {
          label: 'Address Match',
          props: {
            weight: {
              label: 'Weight',
              value:
                getAddressValue() &&
                get(addressDetailsRoot, '1.details.1.value')
                  ? get(addressDetailsRoot, '1.details.1.value')
                      .toFixed(2)
                      .toString()
                  : '-'
            },
            score: {
              label: 'Score',
              value:
                getAddressValue() &&
                get(addressDetailsRoot, '1.details.0.value')
                  ? get(addressDetailsRoot, '1.details.0.value')
                      .toFixed(2)
                      .toString()
                  : '-'
            }
          },
          value: getAddressValue()
            ? get(hit, '_source.WATCHPERSON_RESIDENTIAL_ADDRESS.data', '-')
            : '-'
        },
        dateOfBirthMatch: {
          label: 'Date Of Birth Match',
          props: {
            weight: {
              label: 'Weight',
              value:
                getDateOfBirth() && get(dobDetailsRoot, '1.details.1.value')
                  ? get(dobDetailsRoot, '1.details.1.value')
                      .toFixed(2)
                      .toString()
                  : '-'
            },
            score: {
              label: 'Score',
              value:
                getDateOfBirth() && get(dobDetailsRoot, '1.details.0.value')
                  ? get(dobDetailsRoot, '1.details.0.value')
                      .toFixed(2)
                      .toString()
                  : '-'
            }
          },
          value:
            getDateOfBirth() && get(hit, '_source.DATE_OF_BIRTH')
              ? moment(get(hit, '_source.DATE_OF_BIRTH')).format('DD/MM/YYYY')
              : '-'
        },
        countryofBirthMatch: {
          label: 'Country of Birth Match',
          props: {
            weight: {
              label: 'Weight',
              value:
                formData['countryofBirth'] &&
                get(
                  doc_store_fields_mapping,
                  'WATCHLIST_COUNTRY_OF_BIRTH.weight'
                )
                  ? get(
                      doc_store_fields_mapping,
                      'WATCHLIST_COUNTRY_OF_BIRTH.weight'
                    )
                      .toFixed(2)
                      .toString()
                  : '-'
            },
            score: {
              label: 'Score',
              value:
                formData['countryofBirth'] &&
                get(
                  doc_store_fields_mapping,
                  'WATCHLIST_COUNTRY_OF_BIRTH.score'
                )
                  ? get(
                      doc_store_fields_mapping,
                      'WATCHLIST_COUNTRY_OF_BIRTH.score'
                    )
                      .toFixed(2)
                      .toString()
                  : '-'
            }
          },
          value: formData['countryofBirth']
            ? get(hit, '_source.WATCHLIST_COUNTRY_OF_BIRTH', '-')
            : '-'
        },
        nationalityMatch: {
          label: 'Nationality Match',
          props: {
            weight: {
              label: 'Weight',
              value:
                formData['nationality'] &&
                get(doc_store_fields_mapping, 'WATCHLIST_NATIONALITY.weight')
                  ? get(
                      doc_store_fields_mapping,
                      'WATCHLIST_NATIONALITY.weight'
                    )
                      .toFixed(2)
                      .toString()
                  : '-'
            },
            score: {
              label: 'Score',
              value:
                formData['nationality'] &&
                get(doc_store_fields_mapping, 'WATCHLIST_NATIONALITY.score')
                  ? get(doc_store_fields_mapping, 'WATCHLIST_NATIONALITY.score')
                      .toFixed(2)
                      .toString()
                  : '-'
            }
          },
          value: formData['nationality']
            ? get(hit, '_source.WATCHLIST_NATIONALITY', '-')
            : '-'
        }
      };
      data.push(dataObj);
    });
  }

  const HeaderDetails = () => {
    return (
      <div>
        {Object.keys(headerData).map((header, i) => {
          return (
            <div>
              {/* Returning hit Score and hit level row  */}
              <tr
                className={style.tr}
                style={{
                  backgroundColor:
                    header == 'hitDetail' ? '#E0E8F0' : '#FFFFFF',
                  display: 'block'
                }}
                key={i}>
                {header == 'hitDetail' ? (
                  <td className={style.td}>
                    <div style={{ marginTop: '6px' }}>
                      {Object.keys(headerData[header]).map((k, kIndex) => {
                        return (
                          <span key={kIndex} className={style.detail_header}>
                            {headerData?.[header]?.[k]?.label}
                          </span>
                        );
                      })}
                    </div>
                  </td>
                ) : (
                  <td className={style.td}>
                    <p className={style.header}>{headerKeyMapping[header]}</p>
                  </td>
                )}
              </tr>
              {Object.keys(headerData[header]) &&
                Object.keys(headerData[header]).map((key, i) => {
                  if (key == 'hitLevel' || key == 'hitScore') return;
                  //Returning colored tds with weightages
                  if (weightageHeaders.includes(key)) {
                    return (
                      <tr
                        className={style.tr}
                        style={{
                          backgroundColor: i % 2 ? '#EEF4FA' : '#E0E8F0'
                        }}
                        key={i}>
                        <td className={style.td} style={{ display: 'flex' }}>
                          <p className={style.header}>
                            {' '}
                            {headerData?.[header]?.[key]?.label}
                          </p>
                          <div
                            className={style.header}
                            style={{
                              marginLeft: 'auto',
                              justifyContent: 'end',
                              fontWeight: '400',
                              margin: '0px 24px'
                            }}>
                            {/* <div style={{ display: 'flex' }}> */}
                            <span style={{ marginRight: '12px' }}>Weight</span>
                            <span style={{ marginRight: '12px' }}>Score</span>
                            {/* </div> */}
                          </div>
                        </td>
                        <td className={style.td_2}>
                          {/* <p>no mapping</p> */}
                          <div style={{ display: 'flex', width: '288px' }}>
                            <p
                              className={style.header}
                              style={{ width: '156px' }}>
                              {get(headerData, `${header}.${key}.value`, '-') ||
                                '-'}
                            </p>
                            <div
                              className={style.header}
                              style={{
                                marginLeft: 'auto',
                                justifyContent: 'end',
                                fontWeight: '400',
                                width: '60px',
                                marginRight: '36px'
                              }}>
                              <span style={{ marginRight: '12px' }}>
                                {get(
                                  headerData,
                                  `${header}.${key}.props.weight.value`,
                                  '-'
                                )}
                              </span>
                              <span style={{ marginRight: '12px' }}>
                                {get(
                                  headerData,
                                  `${header}.${key}.props.score.value`,
                                  '-'
                                )}
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  }

                  //Returning colored tds
                  return (
                    <tr
                      className={style.tr}
                      style={{
                        backgroundColor: i % 2 ? '#EEF4FA' : '#E0E8F0',
                        display: 'block'
                      }}
                      key={i}>
                      <td className={style.td}>
                        <p className={style.header}>
                          {headerData?.[header]?.[key]?.label}
                        </p>
                      </td>
                      <td className={style.td_2}>
                        <p className={style.header}>
                          {headerData?.[header]?.[key]?.value || '-'}
                        </p>
                      </td>
                    </tr>
                  );
                })}
            </div>
          );
        })}
      </div>
    );
  };
  const HitDetails = (props) => {
    const { data } = props;
    return (
      <div style={{ display: 'inline-block' }}>
        {Object.keys(data).map((header, i) => {
          return (
            <>
              {/* Returning hit Score and hit level row  */}
              <tr
                className={style.tr}
                style={{
                  backgroundColor:
                    header == 'hitDetail' ? '#E0E8F0' : '#FFFFFF',
                  display: 'block'
                  // width: '291px'
                }}
                key={i}>
                {header == 'hitDetail' ? (
                  <td className={style.td}>
                    <div style={{ marginTop: '6px' }}>
                      {Object.keys(data[header]).map((k, kIndex) => {
                        return (
                          <>
                            {data?.[header]?.[k]?.label == 'Hit Score' ? (
                              <span
                                style={{
                                  display: 'flex',
                                  alignItems: 'baseline'
                                }}
                                key={kIndex}>
                                <span
                                  className={style.detail_header}
                                  style={{ fontWeight: '400', width: '30px' }}>
                                  {data?.[header]?.[k]?.value}
                                </span>
                                <span
                                  style={{
                                    width: '60px',
                                    height: '8px',
                                    marginLeft: '8px'
                                  }}>
                                  {data?.[header]?.[k]?.label == 'Hit Score' &&
                                    data?.[header]?.[k]?.value && (
                                      <Progress
                                        percent={data?.[header]?.[k]?.value}
                                        strokeColor={getAlertColorCode(
                                          data?.[header]?.['hitLevel']?.value
                                        )}
                                        showInfo={false}
                                      />
                                    )}
                                </span>
                              </span>
                            ) : (
                              <span
                                key={kIndex}
                                className={style.detail_header}
                                style={{ fontWeight: '400', width: '30px' }}>
                                {data?.[header]?.[k]?.value}
                              </span>
                            )}
                          </>
                        );
                      })}
                    </div>
                  </td>
                ) : (
                  <td className={style.td}></td>
                )}
              </tr>
              <div>
                {Object.keys(data[header]) &&
                  Object.keys(data[header]).map((key, i) => {
                    if (key == 'hitLevel' || key == 'hitScore') return;
                    //Returning colored tds with weightages
                    if (weightageHeaders.includes(key)) {
                      return (
                        <tr
                          className={style.tr}
                          style={{
                            backgroundColor: i % 2 ? '#EEF4FA' : '#E0E8F0'
                          }}
                          key={i}>
                          <td className={style.td_2}>
                            <div style={{ display: 'flex' }}>
                              <p
                                className={style.header}
                                style={{ width: '165px', fontWeight: '400' }}>
                                {get(data, `${header}.${key}.value`, '-') ||
                                  '-'}
                              </p>
                              <div
                                className={style.header}
                                style={{
                                  marginLeft: 'auto',
                                  justifyContent: 'space-around',
                                  fontWeight: '400',
                                  width: '83px',
                                  marginRight: '8px'
                                }}>
                                <span>
                                  {get(
                                    data,
                                    `${header}.${key}.props.weight.value`,
                                    '-'
                                  )}
                                </span>
                                <span>
                                  {get(
                                    data,
                                    `${header}.${key}.props.score.value`,
                                    '-'
                                  )}
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    }

                    //Returning colored tds
                    return (
                      <tr
                        className={style.tr}
                        style={{
                          backgroundColor: i % 2 ? '#EEF4FA' : '#E0E8F0',
                          display: 'block'
                          // width: '291px'
                        }}
                        key={i}>
                        <td className={style.td}>
                          <p
                            className={style.header}
                            style={{ fontWeight: '400' }}>
                            {data?.[header]?.[key]?.value}
                          </p>
                        </td>
                      </tr>
                    );
                  })}
              </div>
            </>
          );
        })}
      </div>
    );
  };
  return (
    <div className={style.resultsContainer}>
      <p className={style.resultsHeader}>Search Result</p>
      <table style={{ display: 'flex' }}>
        <thead className={style.tHead}>
          <HeaderDetails />
        </thead>
        <tbody className={style.tBody}>
          <div className={style.hitsContainer} style={{}}>
            {data?.map((hit) => {
              return <HitDetails data={hit} />;
            })}
          </div>
        </tbody>
      </table>
    </div>
  );
};

export default ResultsComponent;
